import React from 'react';

const GradientStyleSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      className={className}
      onClick={onClick}
      {...props}
    >
      <rect
        width='40'
        height='40'
        rx='6'
        fill='url(#paint0_linear_1396_57403)'
      />
      <path
        d='M0 6C0 2.68629 2.68629 0 6 0H34C37.3137 0 40 2.68629 40 6V16H0V6Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1396_57403'
          x1='0.381097'
          y1='39.5186'
          x2='47.9768'
          y2='16.4781'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D5EDFF' />
          <stop offset='0.099254' stopColor='#D1EBFF' />
          <stop offset='0.178242' stopColor='#E6F3FD' />
          <stop offset='0.236458' stopColor='#F3F9FE' />
          <stop offset='0.358614' stopColor='#F9FCFF' />
          <stop offset='0.480769' stopColor='white' />
          <stop offset='0.821034' stopColor='#F3F9FE' />
          <stop offset='0.869749' stopColor='#E6F3FD' />
          <stop offset='0.916732' stopColor='#D1EBFF' />
          <stop offset='0.998439' stopColor='#D5EDFF' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GradientStyleSVG;
